var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center",attrs:{"id":"principalMap"}},[_c('ReportDetail',{attrs:{"icon":_vm.report_details.icon,"plate":_vm.report_details.plate,"visible":_vm.report_details.visible,"columns":_vm.report_details.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }